import api from "@/api/api";
import utils from "@/utils/index";
import { Toast } from "vant";

// 全局类型声明
/* global Stripe */

export default {
  methods: {
    /**
     * @discribe change locatin.href with post method
     * @method postHref
     * @param {String} url the url jump to
     * @param {String} params the params to new url
     */
    postHref(url, params) {
      // 创建form
      var temp_form = document.createElement("form");
      // 设置form
      temp_form.action = url;
      temp_form.target = "_self";
      temp_form.method = "post";
      temp_form.style.display = "none";
      // 处理需要传递的参数
      var opt = document.createElement("input");
      opt.name = "jsonRequestData";
      opt.value = params;
      temp_form.appendChild(opt);
      document.body.appendChild(temp_form);
      // 提交表单
      temp_form.submit();
    },
    // 支付产品筛选，判断该支付方式下是否支持该支付产品，如果第一个不符合，则依次往后取值，均不支持，则删除该支付方式
    payWayConfigList(payList, productList) {
      let allPayList = [];
      payList = payList || [];
      allPayList = payList.map(item => {
        let curAllProdList = item.productConfigList || [];
        let includesProdList = [];
        includesProdList = curAllProdList.filter(item => {
          return productList.includes(item.productCode);
        });
        item.curPayProductData = includesProdList[0] || {};
        return item;
      });
      allPayList =
        allPayList &&
        allPayList.filter(item => {
          // 过滤没有支付产品的支付方式
          return Object.keys(item.curPayProductData).length > 0;
        });
      return allPayList;
    },
    /**
     * @method handlePaymentCase
     * @param {String} status
     * @description 处理apple-pay和google-pay支付方式
     */
    handlePaymentCase(caseNumber, res) {
      if (caseNumber === 63) {
        console.log("handlePaymentCase 63 - Airwallex card payment");
        // 对于Airwallex卡支付，先准备数据，等脚本加载完成后再显示弹窗
        this.airwallexResponseData = res;
        // 先加载脚本，等加载完成后再显示弹窗
        this.loadAirwallexScript(() => {
          console.log(
            "Airwallex script loaded for card payment, showing popup..."
          );
          // 脚本加载完成后再显示弹窗，确保组件能正确初始化
          this.airwallexPopupShow = true;
        });
        this.queryOrder();
        return;
      }

      // 其他支付方式的处理逻辑
      const data = JSON.parse(res.data.data.url);
      this.loading = true;
      this.clientSecret = JSON.parse(data.paymentIntent).client_secret;
      this.countryCode = data.countryCode;
      this.payTradeNo = res.data.data.payTradeNo;

      if (caseNumber === 49) {
        // Google Pay: 先显示弹窗，然后使用nextTick确保DOM更新后再创建按钮
        this.googleOApplePayShow = true;
        this.$nextTick(() => {
          console.log("Google Pay: DOM updated, loading Airwallex script...");
          this.loadAirwallexScript(() => {
            console.log(
              "Google Pay: Airwallex script loaded, creating button..."
            );
            // 增加额外的延时确保弹窗完全渲染
            setTimeout(() => {
              this.createGooglePayButton(this.clientSecret);
            }, 200);
          });
        });
      } else if (caseNumber === 51) {
        // Apple Pay: 先显示弹窗，然后使用nextTick确保DOM更新后再创建按钮
        this.googleOApplePayShow = true;
        this.$nextTick(() => {
          console.log("Apple Pay: DOM updated, loading Airwallex script...");
          this.loadAirwallexScript(() => {
            console.log(
              "Apple Pay: Airwallex script loaded, creating button..."
            );
            // 增加额外的延时确保弹窗完全渲染
            setTimeout(() => {
              this.createApplePayButton(this.clientSecret);
            }, 200);
          });
        });
      }
      this.queryOrder();
    },
    loadAirwallexScript(callback) {
      console.log(
        "loadAirwallexScript called, window.Airwallex exists:",
        !!window.Airwallex
      );
      if (window.Airwallex) {
        this.initializeAirwallex();
        if (callback) callback();
        return;
      }
      console.log("Loading Airwallex script...");
      this.loadScript(
        "https://checkout.airwallex.com/assets/elements.bundle.min.js",
        () => {
          console.log("Airwallex script loaded successfully");
          this.initializeAirwallex();
          if (callback) callback();
        }
      );
    },
    initializeAirwallex() {
      console.log(
        "Mixins initializeAirwallex called, Airwallex available:",
        typeof Airwallex !== "undefined"
      );
      if (typeof Airwallex !== "undefined") {
        // Initialize Airwallex
        // 判断当前环境
        const airwallexEnv =
          this.goodInfo.airwallexEnv === "LIVE" ? "prod" : "demo";
        console.log("Airwallex environment:", airwallexEnv);
        window.Airwallex.init({
          env: airwallexEnv, // Setup which Airwallex env('staging' | 'demo' | 'prod') to integrate with
          origin: window.location.origin // Setup your event target to receive the browser events message
        });
        console.log("Airwallex initialized successfully");
        this.loading = false;
      } else {
        console.error("Airwallex is not available.");
      }
    },

    /**
     * @method createApplePayButton
     * @description apple支付
     */
    createApplePayButton(client_secret) {
      const _this = this;
      const totalPriceLabel =
        utils.getUrlSearch("totalPriceLabel") || "Think Academy";

      // 创建DOM检查和重试机制
      const checkDOMAndCreateButton = (retryCount = 0) => {
        const maxRetries = 10; // 最多重试10次
        const retryDelay = 100; // 每次重试间隔100ms

        console.log(`Apple Pay: Attempt ${retryCount + 1} to find DOM element`);

        // 检查 DOM 元素是否存在
        const targetElement = document.getElementById("googleOrApplePayButton");
        if (!targetElement) {
          if (retryCount < maxRetries) {
            console.log(
              `Apple Pay: Target element not found, retrying in ${retryDelay}ms...`
            );
            setTimeout(() => {
              checkDOMAndCreateButton(retryCount + 1);
            }, retryDelay);
            return;
          } else {
            console.error(
              "Apple Pay: Target element 'googleOrApplePayButton' not found after maximum retries"
            );
            _this.loading = false;
            return;
          }
        }

        console.log(
          "Apple Pay: Target element found, creating Apple Pay button"
        );

        try {
          const element = window.Airwallex.createElement("applePayButton", {
            countryCode: _this.countryCode,
            totalPriceLabel: totalPriceLabel,
            amount: {
              value: this.goodInfo.totalFee,
              currency: this.goodInfo.currency
            },
            requiredShippingContactFields: [],
            requiredBillingContactFields: [],
            merchantCapabilities: [
              "supports3DS",
              "supportsDebit",
              "supportsCredit",
              "supportsEMV"
            ],
            supportedNetworks: [
              "visa",
              "masterCard",
              "chinaUnionPay",
              "amex",
              "discover"
            ]
          });

          console.log("Apple Pay: Element created, mounting to DOM");
          element.mount("googleOrApplePayButton");

          // element挂载完成
          element.on("ready", async () => {
            console.log("Apple Pay ready====start");
            this.loading = false;
          });

          element.on("validateMerchant", async event => {
            try {
              let params = {
                validation_url: event?.detail?.validationURL,
                initiative_context: window.location.hostname,
                merchantPayNo: utils.getUrlSearch("merchantPayNo"),
                payTradeNo: this.payTradeNo
              };

              api.apiMethod.appleValidateMerchant
                .post(params, {
                  checkoutToken: utils.getUrlSearch("checkoutToken")
                })
                .then(merchantSession => {
                  if (merchantSession) {
                    element.completeValidation(
                      JSON.parse(merchantSession.data.data)
                    );
                  }
                });
            } catch (error) {
              // toast错误
              Toast.fail(
                error.message ? error.message : "Error validating merchant."
              );
              console.error("Error validating merchant:", error);
            }
          });

          console.log("Apple Pay authorized====start");
          element.on("authorized", async () => {
            element
              .confirmIntent({ client_secret })
              .then(res => {
                console.log(res, "Apple Pay Payment confirmed.");
                if (res.status == "SUCCEEDED" && this.goodInfo.returnUrl) {
                  window.location.href = this.goodInfo.returnUrl;
                } else {
                  // toast错误
                  Toast.fail(res.status);
                }
              })
              .catch(error => {
                console.warn(error.message);
              });
          });

          element.on("error", event => {
            // toast错误
            Toast.fail(event.error.message);
            console.error("Apple Pay: There was an error", event);
          });
        } catch (error) {
          console.error("Apple Pay: Error creating element", error);
          _this.loading = false;
        }
      };

      // 开始检查DOM并创建按钮
      checkDOMAndCreateButton();
    },
    /**
     * @method createGooglePayButton
     * @description google支付
     */
    createGooglePayButton(client_secret) {
      const _this = this;

      // 创建DOM检查和重试机制
      const checkDOMAndCreateButton = (retryCount = 0) => {
        const maxRetries = 10; // 最多重试10次
        const retryDelay = 100; // 每次重试间隔100ms

        console.log(
          `Google Pay: Attempt ${retryCount + 1} to find DOM element`
        );

        // 检查 DOM 元素是否存在
        const targetElement = document.getElementById("googleOrApplePayButton");
        if (!targetElement) {
          if (retryCount < maxRetries) {
            console.log(
              `Google Pay: Target element not found, retrying in ${retryDelay}ms...`
            );
            setTimeout(() => {
              checkDOMAndCreateButton(retryCount + 1);
            }, retryDelay);
            return;
          } else {
            console.error(
              "Google Pay: Target element 'googleOrApplePayButton' not found after maximum retries"
            );
            _this.loading = false;
            return;
          }
        }

        console.log(
          "Google Pay: Target element found, creating Google Pay button"
        );

        try {
          const element = window.Airwallex.createElement("googlePayButton", {
            countryCode: _this.countryCode,
            billingAddressRequired: false,
            // billingAddressParameters: {
            //   format: 'FULL',
            // },
            shippingOptionRequired: false,
            shippingAddressRequired: false,
            amount: {
              value: this.goodInfo.totalFee,
              currency: this.goodInfo.currency
            },
            callbackIntents: ["PAYMENT_AUTHORIZATION"]
          });

          console.log("Google Pay: Element created, mounting to DOM");
          element.mount("googleOrApplePayButton");

          // element挂载完成
          element.on("ready", async () => {
            console.log("Google Pay ready====start");
            this.loading = false;
          });

          element.on("authorized", async () => {
            element
              .confirmIntent({ client_secret })
              .then(res => {
                console.log(res, "Google Pay Payment confirmed.");
                if (res.status == "SUCCEEDED" && this.goodInfo.returnUrl) {
                  window.location.href = this.goodInfo.returnUrl;
                } else {
                  // toast错误
                  Toast.fail(res.status);
                }
              })
              .catch(error => {
                // toast错误
                Toast.fail(error.message);
              });
          });

          element.on("error", event => {
            // toast错误
            Toast.fail(event.error.message);
            console.error("Google Pay: There was an error", event);
          });
        } catch (error) {
          console.error("Google Pay: Error creating element", error);
          _this.loading = false;
        }
      };

      // 开始检查DOM并创建按钮
      checkDOMAndCreateButton();
    },
    loadScript(url, callback) {
      var script = document.createElement("script");
      script.src = url;
      script.async = true;
      script.onload = function() {
        if (callback) {
          callback();
        }
      };
      // 处理脚本加载错误的情况（可选）
      script.onerror = function() {
        console.error("Failed to load script:", url);
      };
      // 将 script 元素插入到文档的 <head> 或 <body> 中
      document.head.appendChild(script);
    },
    supportsApplePay() {
      if (window.ApplePaySession) {
        return window.ApplePaySession.canMakePayments();
      }
      return false;
    },
    /**
     * @method timeFormat
     * @description 小于10的数字前置0
     */
    timeFormat(param) {
      return param < 10 ? "0" + param : param;
    },
    /**
     * @method countDown
     * @description 根据剩余秒数进行倒计时并在结束时触发超时处理
     * @param {number} remainingSeconds 剩余秒数
     */
    countDown(remainingSeconds) {
      // Generated by AI start - Cursor - 2024-12-19
      // 清除可能存在的旧倒计时定时器
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }

      let remainingTime = remainingSeconds;

      const updateCountDown = () => {
        let obj = null;
        if (remainingTime > 0) {
          // 计算小时、分钟、秒（remainingTime已经是秒数）
          const hou = Math.floor(remainingTime / 3600);
          const min = Math.floor((remainingTime % 3600) / 60);
          const sec = remainingTime % 60;

          obj = {
            hou: this.timeFormat(hou),
            min: this.timeFormat(min),
            sec: this.timeFormat(sec)
          };

          this.countDownList = obj.hou + ":" + obj.min + ":" + obj.sec;
          remainingTime--; // 每秒减1
          return true;
        } else {
          // 倒计时结束
          obj = { hou: "00", min: "00", sec: "00" };
          this.countDownList = obj.hou + ":" + obj.min + ":" + obj.sec;
          this.subStatusResult(7);
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
          return false;
        }
      };

      // 立即执行一次更新
      if (updateCountDown()) {
        // 设置定时器，每秒更新一次
        this.countdownInterval = setInterval(updateCountDown, 1000);
      }
      // Generated by AI end
    },
    // 上报日志
    reportLog(params) {
      // 增加merchantPayNo
      // params.merchantPayNo = utils.getUrlSearch("merchantPayNo");
      // 通过路由判断是否是/sub或者/subpc
      const isSub =
        this.$route.path.includes("/sub") ||
        this.$route.path.includes("/subpc") ||
        this.$route.path.includes("/subAchCardList");
      console.log(isSub, "isSub======");
      const uploadType = isSub ? 2 : 1;
      if (isSub) {
        params.merchantStageNo = utils.getUrlParmas(
          window.location.href
        ).merchantStageNo;
      } else {
        params.merchantPayNo = utils.getUrlParmas(
          window.location.href
        ).merchantPayNo;
      }
      // 确保msg参数始终通过JSON.stringify()转换
      if (params.msg !== undefined && params.msg !== null) {
        if (typeof params.msg !== "string") {
          params.msg = JSON.stringify(params.msg);
        } else {
          // 如果已经是字符串，检查是否是有效的JSON，如果不是则包装一下
          try {
            JSON.parse(params.msg);
            // 如果能解析说明已经是JSON字符串，保持不变
          } catch {
            // 如果不能解析，说明是普通字符串，需要转换
            params.msg = JSON.stringify(params.msg);
          }
        }
      }

      api.apiMethod.reportLog
        .post(params, {
          checkoutToken: utils.getUrlSearch("checkoutToken"),
          uploadType: uploadType
        })
        .then(res => {
          console.log(res, "====res");
        });
    },
    /**
     * @method queryOrder
     * @description 查询订单状态
     */
    async queryOrder(loading, app) {
      const businessCode =
        utils.getUrlSearch("businessCode") || this.goodInfo.businessCode;
      const merchantPayNo =
        utils.getUrlSearch("merchantPayNo") || this.goodInfo.merchantOrderNo;
      const merchantCode =
        utils.getUrlSearch("merchantCode") || this.goodInfo.merchantCode;
      try {
        // 显示加载提示
        if (loading || app) {
          Toast.loading({
            message: this.$i18n.t("common.loadingCommonText"),
            forbidClick: false,
            duration: 0
          });
        }

        // 创建轮询机制
        let pollingCount = 0;
        const maxPollingCount = 20; // 最多查询20次
        const pollingInterval = 3000; // 每3秒查询一次

        // 清除可能存在的旧定时器
        if (this.interval) {
          clearInterval(this.interval);
        }

        // 创建新的轮询定时器
        this.interval = setInterval(async () => {
          pollingCount++;

          try {
            // 调用查询订单接口
            const res = await api.apiMethod.queryOrder.post(
              {
                businessCode,
                merchantPayNo,
                merchantCode
              },
              {
                checkoutToken: utils.getUrlSearch("checkoutToken")
              }
            );

            console.log("查询订单状态结果:", res);

            // 检查响应状态
            if (res.data && res.data.code === 10000) {
              Toast.clear();
              const data = res.data.data;
              const orderStatus = data.status;

              // 处理不同的订单状态
              if (orderStatus === 0) {
                // 订单待处理，继续轮询
                console.log("订单待付款，继续查询...");
                if (pollingCount >= maxPollingCount) {
                  // 超过最大查询次数，停止轮询
                  clearInterval(this.interval);
                  this.isQueryingOrder = false;
                  Toast.clear();
                  Toast.fail(
                    this.$i18n.t("common.queryTimeout") ||
                      "查询超时，请稍后再试"
                  );
                }
              } else if (orderStatus === 1) {
                // 订单成功，停止轮询并跳转
                clearInterval(this.interval);
                this.isQueryingOrder = false;
                Toast.clear();

                // 获取翻译文本
                const successMsg =
                  this.$i18n.t("common.paymentSuccess") || "支付成功";

                // 如果是英文，则分行处理
                if (this.$i18n.locale === "en") {
                  // 分割文本成两行
                  const words = successMsg.split(" ");
                  // 使用换行符分隔单词
                  const formattedMsg = `${words[0]}\n${words[1] || ""}`;

                  Toast.success({
                    message: formattedMsg,
                    className: "toast-wrap"
                  });
                } else {
                  // 非英文直接显示
                  Toast.success({
                    message: successMsg,
                    className: "toast-wrap"
                  });
                }

                // 调用支付结果处理方法
                // this.payStatusResult(1, app);
                // 若果是app延时5s
                if (app) {
                  setTimeout(() => {
                    this.payStatusResult(1, app);
                    // 上报支付成功日志
                    this.reportLog({
                      eventId: "PAYSUCCESS_APP",
                      msg: ""
                    });
                  }, 200);
                } else {
                  this.payStatusResult(1, app);
                  // 上报支付成功日志
                  this.reportLog({
                    eventId: "PAYSUCCESS_H5_PC",
                    msg: ""
                  });
                }
              } else if (orderStatus === 2) {
                // 订单失败，停止轮询
                clearInterval(this.interval);
                this.isQueryingOrder = false;
                Toast.clear();
                this.payStatusResult(2);
              } else if (orderStatus === 3) {
                // 订单取消或超时，停止轮询
                clearInterval(this.interval);
                this.isQueryingOrder = false;
                Toast.clear();
                this.payStatusResult(3);
              }
            } else {
              // API请求成功但返回错误码
              console.error("查询订单状态接口返回错误:", res);
              if (pollingCount >= maxPollingCount) {
                clearInterval(this.interval);
                this.isQueryingOrder = false;
                Toast.clear();
                Toast.fail(
                  this.$i18n.t("common.queryError") || "查询出错，请稍后再试"
                );
              }
            }
          } catch (error) {
            // API请求失败
            console.error("查询订单状态接口调用失败:", error);
            if (pollingCount >= maxPollingCount) {
              clearInterval(this.interval);
              this.isQueryingOrder = false;
              Toast.clear();
              Toast.fail(
                this.$i18n.t("common.queryError") || "查询出错，请稍后再试"
              );
            }
          }
        }, pollingInterval);
      } catch (error) {
        // 处理初始化查询时的错误
        console.error("初始化查询订单状态失败:", error);
        this.isQueryingOrder = false;
        Toast.clear();
        Toast.fail(this.$i18n.t("common.queryError") || "查询出错，请稍后再试");
      }
    },
    /**
     * @method payStatusResult
     * @param {String} status
     * @description 根据支付状态改变结果
     */
    payStatusResult(status, app) {
      if (status === 1) {
        // console.log(this.returnUrl, "this.returnUrl====");
        if (app) {
          // 区分环境
          const fetchPaySuccessedMessage = {
            errcode: 10000,
            errmsg: "success"
          };
          switch (this.$route.query.app) {
            case "iOS":
              window.webkit.messageHandlers.fetchPaySuccessedMessage.postMessage(
                JSON.stringify(fetchPaySuccessedMessage)
              );
              // 上报支付成功日志
              this.reportLog({
                eventId: "PAYSUCCESS_APP_IOS",
                msg: ""
              });
              break;
            case "android":
              window.talGlobalTradeSdk.fetchPaySuccessedMessage(
                JSON.stringify(fetchPaySuccessedMessage)
              );
              // 上报支付成功日志
              this.reportLog({
                eventId: "PAYSUCCESS_APP_ANDROID",
                msg: ""
              });
              break;
            default:
              break;
          }
        }
        // 确保有returnUrl并且是一个有效的URL

        if (this.returnUrl) {
          // 记录跳转日志
          let params = {
            eventId: "REDIRECT_TO_RETURN_URL",
            msg: this.returnUrl
          };
          this.reportLog(params);
          window.location.href = this.returnUrl;
          return;
        }
        console.log("successResult", "this.goodInfo====");
        this.$router.push({
          path: "/successResult",
          query: {
            currencySymbol: this.goodInfo.currencySymbol,
            totalFee: this.goodInfo.totalFee,
            goodsDetail: this.goodInfo.goodsDetail,
            goodsName: this.goodInfo.goodsName
          }
        });
      } else {
        if (status === 2) {
          console.log(this.$i18n.locale, "this.$i18n.locale ===2");
          this.dialogShow = true;
          this.srcPath = "payment_failure_move";
          this.failText =
            this.$i18n.locale === "en"
              ? "Payment failed. Please pay again."
              : this.$i18n.locale === "zh"
              ? "支付失败，请重新支付"
              : this.$i18n.locale === "fr"
              ? "Le paiement a échoué. Veuillez payer à nouveau."
              : this.$i18n.locale === "ja"
              ? "支払いに失敗しました。もう一度支払ってください。"
              : this.$i18n.locale === "ko"
              ? "결제 실패. 다시 결제하십시오."
              : "支付失败，请重新支付";
        } else if (status === 3) {
          console.log(this.$i18n.locale, "this.$i18n.locale ====3");
          this.dialogShow = true;
          this.srcPath = "order_invalid_move";
          this.failText =
            this.$i18n.locale === "en"
              ? "The order has expired. Please make a new order."
              : this.$i18n.locale === "zh"
              ? "订单已过期，请重新下单"
              : this.$i18n.locale === "fr"
              ? "La commande a expiré. Veuillez passer une nouvelle commande."
              : this.$i18n.locale === "ja"
              ? "注文が期限切れになりました。新しい注文をしてください。"
              : this.$i18n.locale === "ko"
              ? "주문이 만료되었습니다. 새 주문을하십시오."
              : "订单已过期，请重新下单";
        }
      }
    },
    /**
     * @method subscriptionQueryOrder
     * @description 查询订单状态
     * @param {Boolean} loading - 是否显示加载状态
     * @param {Boolean} app - 是否为APP环境
     */
    async subscriptionQueryOrder(loading, app) {
      const getParamValue = (urlKey, fallbackKey) => {
        const urlValue = utils.getUrlSearch(urlKey);
        if (app) {
          return urlValue || "";
        }
        return urlValue || this.goodInfo[fallbackKey] || "";
      };

      const businessCode = getParamValue("businessCode", "businessCode");
      const merchantPayNo = getParamValue("merchantStageNo", "merchantStageNo");
      const merchantCode = getParamValue("merchantCode", "merchantCode");
      const merchantStageNo = getParamValue("merchantStageNo", "merchantStageNo");

      if (!app) {
        this.returnUrl = utils.getUrlSearch("returnUrl") ? utils.getUrlSearch("returnUrl") : this.goodInfo.returnUrl || "";
      }
      this.reportLog({
        eventId: "05_05_01_00",
        msg: merchantStageNo
      });
      try {
        // 显示加载提示
        if (loading || app) {
          Toast.loading({
            message: this.$i18n.t("common.loadingCommonText"),
            forbidClick: false,
            duration: 0
          });
        }

        // 创建轮询机制
        let pollingCount = 0;
        const maxPollingCount = 50; // 最多查询20次
        const pollingInterval = 3000; // 每3秒查询一次

        // 清除可能存在的旧定时器
        if (this.subscriptionQueryInterval) {
          clearInterval(this.subscriptionQueryInterval);
        }

        // 创建新的轮询定时器
        this.subscriptionQueryInterval = setInterval(async () => {
          pollingCount++;

          try {
            // 调用查询订单接口
            const res = await api.apiMethod.subscriptionCheckoutQuery.post(
              {
                businessCode,
                merchantPayNo,
                merchantCode,
                merchantStageNo
              },
              {
                checkoutToken: utils.getUrlSearch("checkoutToken")
              }
            );

            console.log("查询订单状态结果:", res);

            // 检查响应状态
            if (res.data && res.data.code === 10000) {
              // Toast.clear();
              const data = res.data.data;
              const orderStatus = data.status;
              // 如果是app，则调用支付结果处理方法
              // 如果是payProduct为81
              // const payProduct = utils.getUrlSearch("payProduct");
              if (app) {
                //  2不做处理 1-6进成功页面 7超时
                if (orderStatus >= 1 && orderStatus <= 6 && orderStatus !== 2) {
                  this.handleAppAchSubscriptionSuccess();
                  return;
                }
              }
              this.reportLog({
                eventId: "05_05_02_00",
                msg: orderStatus
              });
              this.subStatusResult(orderStatus);
            } else {
              // API请求成功但返回错误码
              console.error("查询订单状态接口返回错误:", res);
              if (pollingCount >= maxPollingCount) {
                clearInterval(this.subscriptionQueryInterval);
                this.isQueryingOrder = false;
                // Toast.clear();
                Toast.fail(
                  this.$i18n.t("common.queryError") || "查询出错，请稍后再试"
                );
              }
            }
          } catch (error) {
            // API请求失败
            console.error("查询订阅状态接口调用失败:", error);
            if (pollingCount >= maxPollingCount) {
              clearInterval(this.subscriptionQueryInterval);
              this.isQueryingOrder = false;
              Toast.clear();
              Toast.fail(
                this.$i18n.t("common.queryError") || "查询出错，请稍后再试"
              );
            }
          }
        }, pollingInterval);
      } catch (error) {
        // 处理初始化查询时的错误
        console.error("初始化查询订单状态失败:", error);
        this.isQueryingOrder = false;
        Toast.clear();
        Toast.fail(this.$i18n.t("common.queryError") || "查询出错，请稍后再试");
      }
    },
    // 获取时区希望获取格式如 Asia/Tokyo
    getTimeZone() {
      // Generated by AI start - Cursor - 2024-12-19
      try {
        // 使用 Intl.DateTimeFormat 获取时区信息
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        console.log("当前时区:", timezone);
        return timezone;
      } catch (error) {
        console.error("获取时区失败:", error);
        // 如果获取失败，返回 UTC 作为默认值
        return "UTC";
      }
      // Generated by AI end
    },
    // 通用的Stripe Express Checkout方法
    createStripeExpressCheckout(
      paymentMethod,
      stripePublishableKey,
      countryCode,
      merchantName,
      stripeEnv,
      clientSecret,
      options = {}
    ) {
      console.log(`createStripeExpressCheckout for ${paymentMethod}====start`);
      console.log("Stripe====", typeof Stripe);
      console.log("=====测试=stripePublishableKey===是否更换=", stripePublishableKey);

      // 检查Stripe是否已加载
      if (typeof Stripe === "undefined") {
        console.error("Stripe.js not loaded!");
        Toast.fail("Stripe支付服务未加载，请刷新页面重试");
        return;
      }

      try {
        // 使用传入的参数
        const stripe = new Stripe(stripePublishableKey);

        // 根据支付方式选择对应的DOM元素
        const buttonSelector = "#stripeExpressCheckoutButton";
        const paymentButton = document.querySelector(buttonSelector);

        console.log(`${paymentMethod} button element:`, paymentButton);

        if (!paymentButton) {
          console.error(
            `${paymentMethod} button element not found: ${buttonSelector}`
          );
          return;
        }

        // 使用实际的支付金额和货币
        // const amount = 50000; // 转换为最小货币单位
        // const currency = "myr";

        // 检查金额是否有效
        // if (amount <= 0) {
        //   console.error("Invalid payment amount:", amount);
        //   Toast.fail("支付金额无效");
        //   return;
        // }

        console.log("Payment config:", {
          amount: this.amount,
          currency: this.currency,
          locale: this.$i18n?.locale || "en"
        });

        // 默认配置
        const defaultOptions = {
          paymentMethods: {
            googlePay: paymentMethod === "googlePay" ? "always" : "never",
            applePay: paymentMethod === "applePay" ? "always" : "never",
            link: "never" // 不支持银行卡支付
          },
          buttonHeight: 50
        };

        // 支付方式特定配置
        const paymentMethodOptions = {
          googlePay: {
            merchantInfo: {
              merchantName: merchantName
            },
            transactionInfo: {
              countryCode: countryCode // 设置国家代码
            },
            environment: stripeEnv,
            // 允许的支付方式
            allowedPaymentMethods: {
              type: "CARD",
              parameters: {
                allowedAuthMethods: ["PAN_ONLY", "CRYPTOGRAM_3DS"],
                allowedCardNetworks: [
                  "VISA",
                  "MASTERCARD",
                  "AMEX",
                  "DISCOVER",
                  "JCB",
                  "UNIONPAY"
                ]
              }
            },
            buttonType: { googlePay: "buy" }, // 重复配置
            buttonTheme: { googlePay: "black" }, // 重复配置
            existingPaymentMethodRequired: false
          },
          applePay: {
            merchantName: merchantName,
            countryCode: countryCode, // 根据您的业务地区调整
            environment: stripeEnv,
            // 支持的卡网络 - 根据优先级排序
            supportedNetworks: [
              "visa", // 通常放在前面
              "masterCard",
              "amex",
              "discover"
            ],
            // 商家功能 - Web 端适用的选项
            merchantCapabilities: [
              "supports3DS", // 支持 3D Secure 验证 (推荐)
              "supportsCredit", // 支持信用卡
              "supportsDebit" // 支持借记卡
            ],
            buttonType: {
              applePay: "buy"
            },
            buttonTheme: {
              applePay: "black"
            }
          }
        };

        const expressCheckoutOptions = {
          ...defaultOptions,
          ...paymentMethodOptions[paymentMethod],
          ...options // 允许额外覆盖配置
        };

        const appearance = {
          theme: "stripe",
          variables: {
            borderRadius: "6px"
          }
        };

        console.log("Creating elements with config:", {
          mode: "payment",
          amount: this.amount,
          currency: this.currency,
          locale: this.$i18n?.locale || "en"
        });

        const elements = stripe.elements({
          locale: this.$i18n?.locale || "en",
          mode: "payment",
          amount: Number(this.amount),
          currency: this.currency,
          paymentMethodTypes: ["card"],
          appearance: appearance
        });

        console.log("Elements created successfully");

        const expressCheckoutElement = elements.create(
          "expressCheckout",
          expressCheckoutOptions
        );
        console.log("Express checkout element created");

        console.log("Mounting element...");
        expressCheckoutElement.mount(paymentButton);
        console.log("Element mounted successfully");

        // 添加事件监听器
        expressCheckoutElement.on("confirm", async event => {
          console.log("Payment confirmation started:", event);

          try {
            // 使用传入的client secret

            if (!clientSecret) {
              console.error("No client secret available");
              Toast.fail("支付配置错误，请稍后重试");
              return;
            }

            const result = await stripe.confirmPayment({
              elements,
              clientSecret,
              redirect: "if_required",
              confirmParams: {
                // return_url: this.goodInfo?.returnUrl || window.location.href
              }
            });

            if (result.error) {
              console.error("Payment confirmation failed:", result.error);
              Toast.fail(`支付失败: ${result.error.message}`);
            } else if (result.paymentIntent) {
              switch (result.paymentIntent.status) {
                case "succeeded":
                  console.log("Payment successful:", result.paymentIntent);
                  // 处理支付成功
                  this.handlePaymentSuccess(result);
                  break;
                case "processing":
                  console.log("Payment processing:", result.paymentIntent);
                  // 处理支付处理中
                  // this.handlePaymentProcessing(result);
                  break;
                case "requires_payment_method":
                  console.log(
                    "Payment requires payment method:",
                    result.paymentIntent
                  );
                  // 处理支付需要新的支付方式
                  //  this.handlePaymentRequiresPaymentMethod(result);
                  break;
                default:
                  console.error(
                    "Payment unknown status:",
                    result.paymentIntent
                  );
                  Toast.fail("支付状态未知，请稍后重试");
                  break;
              }
            } else {
              console.error("Payment unknown status:", result);
              Toast.fail("支付状态未知，请稍后重试");
            }
          } catch (error) {
            console.error("Payment confirmation error:", error);
            Toast.fail("支付处理出错，请重试");
          } finally {
            console.log("Payment confirmation completed");
          }
        });
        expressCheckoutElement.on("ready", event => {
          console.log("Express checkout ready:", event);

          const { availablePaymentMethods } = event;
          console.log("Available payment methods:", availablePaymentMethods);

          // 设置loading状态
          this.loading = false;

          // 检查支付方式的可用性
          if (availablePaymentMethods) {
            const hasGooglePay = availablePaymentMethods.googlePay || false;
            const hasApplePay = availablePaymentMethods.applePay || false;

            console.log("Payment method availability:", {
              hasGooglePay,
              hasApplePay
            });

            // 根据当前支付方式检查可用性
            const isCurrentMethodAvailable =
              paymentMethod === "googlePay" ? hasGooglePay : hasApplePay;

            if (isCurrentMethodAvailable) {
              console.log(`${paymentMethod} is available`);
            } else {
              console.log(`No ${paymentMethod} available`);
              Toast.fail(`${
                paymentMethod === "googlePay" ? "Google Pay" : "Apple Pay"
              }不可用，请尝试其他支付选项`);
            }
          } else {
            console.warn("No available payment methods information");
          }
        });

        expressCheckoutElement.on("cancel", () => {
          console.log("Payment cancelled by user");
        });

        console.log("Event listeners added successfully");
      } catch (error) {
        console.error(
          `Error in createStripeExpressCheckout for ${paymentMethod}:`,
          error
        );
        console.error("Error stack:", error.stack);
        Toast.fail("支付服务初始化失败，请稍后重试");
      }
    },

    // stripe google pay
    stripeGooglePay(caseNumber, res, stripePublishableKey) {
      console.log("stripeGooglePay====start");
      // letclientSecret从url获取
      // const clientSecret = utils.getUrlSearch("clientSecret")
      const data = JSON.parse(res.data.data.packageParams);
      console.log("data=====data=====", data);
      this.clientSecret = data.clientSecret;
      this.amount = this.goodInfo.originalTotalFee;
      this.currency = this.goodInfo.currency.toLowerCase();
      // 先显示弹窗
      this.stripeExpressCheckoutPopupShow = true;
      // 等待DOM更新后再创建按钮
      this.$nextTick(() => {
        console.log("Google Pay: DOM updated, loading Stripe script...");
        this.loadAirwallexScript(() => {
          console.log(
            "Google Pay: Airwallex script loaded, creating button..."
          );
          // 增加额外的延时确保弹窗完全渲染
          setTimeout(() => {
            this.createStripeExpressCheckout(
              "googlePay",
              stripePublishableKey,
              this.countryCode,
              this.merchantName,
              this.stripeEnv,
              this.clientSecret
            );
          }, 200);
        });
      });
    },

    // stripe apple pay
    stripeApplePay(caseNumber, res, stripePublishableKey) {
      console.log("stripeApplePay====start");
      const data = JSON.parse(res.data.data.packageParams);
      console.log("data=====data=====", data);
      this.clientSecret = data.clientSecret;
      this.amount = this.goodInfo.originalTotalFee;
      // currency变为小写
      this.currency = this.goodInfo.currency.toLowerCase();
      // 先显示弹窗
      this.stripeExpressCheckoutPopupShow = true;
      // 等待DOM更新后再创建按钮
      this.$nextTick(() => {
        console.log("Apple Pay: DOM updated, loading Stripe script...");
        this.loadAirwallexScript(() => {
          console.log("Apple Pay: Airwallex script loaded, creating button...");
          // 增加额外的延时确保弹窗完全渲染
          setTimeout(() => {
            this.createStripeExpressCheckout(
              "applePay",
              stripePublishableKey,
              this.countryCode,
              this.merchantName,
              this.stripeEnv,
              this.clientSecret
            );
          }, 200);
        });
      });
    },


    // 处理支付成功的回调
    handlePaymentSuccess(result) {
      console.log("Handling payment success:", result);
      window.location.href = this.goodInfo.returnUrl;
      this.reportLog({
        eventId: "PAYMENTSUCCESS_stripe",
        caseNumber: this.caseNumber,
        msg: JSON.stringify(result)
      });
      // 触发支付成功事件
      // if (this.checkoutValue == 77 || this.checkoutValue == 80) {
      //   // merchantPayNo checkoutToken
      //   window.location.href = url;
      //   this.reportLog({
      //     eventId: "PAYMENTSUCCESS_stripe_pc",
      //     caseNumber: this.caseNumber,
      //     msg: JSON.stringify(result)
      //   });
      // } else {
      //   this.payStatusResult(1);
      //   this.reportLog({
      //     eventId: "PAYMENTSUCCESS_stripe_moblie",
      //     caseNumber: this.caseNumber,
      //     msg: JSON.stringify(result)
      //   });
      // }
    },
    // 处理app的ach订阅成功
    handleAppAchSubscriptionSuccess() {
      // 上报日志，eventId: "SUBSCRIPTION_SUCCESS"
      this.reportLog({
        eventId: "SUBSCRIPTION_SUCCESS_ACH_APP",
        msg: ""
      });
      // 区分环境
      const fetchPaySuccessedMessage = {
        errcode: 10000,
        errmsg: "success"
      };
      switch (this.$route.query.app) {
        case "iOS":
          window.webkit.messageHandlers.fetchPaySuccessedMessage.postMessage(
            JSON.stringify(fetchPaySuccessedMessage)
          );
          break;
        case "android":
          window.talGlobalTradeSdk.fetchPaySuccessedMessage(
            JSON.stringify(fetchPaySuccessedMessage)
          );
          break;
        default:
          break;
      }
    }
  }
};
